<ng-container
  *ngIf="moduleId != undefined && moduleId != 'NaN' && moduleId !== '0' && moduleStructure !== undefined"
>
  <div
    *ngIf="openedObjects.length > 0 && displayOpenedObjectHistory"
    nz-row
    [nzGutter]="[6, 6]"
    class="opened-tabs s-h m-h xs-h"
    [ngClass]="{ 'affix-active': pageHeaderAffix }"
  >
    <ng-container *ngFor="let obj of openedObjects">
      <div class="tab-container">
        <button
          nz-button
          class="delete-button"
          [nzType]="'text'"
          (click)="deleteObj(obj)"
        >
          <i class="fal fa-remove"></i>
        </button>
        <button
          nz-button
          nz-tooltip
          [nzTooltipTitle]="obj.fullTitle"
          nzTooltipPlacement="right"
          (click)="navigateToObj(obj)"
          [nzType]="
            selectedRecords[0] != null &&
            obj.recordId == selectedRecords[0].toString()
              ? 'default'
              : 'text'
          "
          style="width: 100%"
        >
          <ng-template #indicatorTemplate
            ><i nz-icon nzType="loading"></i
          ></ng-template>
          <span *ngIf="obj.title == null">
            <nz-spin nzSimple [nzIndicator]="indicatorTemplate"></nz-spin>
          </span>
          <span
            *ngIf="obj.title != null"
            nz-typography
            nzEllipsis
            style="width: 100%; text-align: left"
          >
            {{ obj.fullTitle }}
          </span>
        </button>
      </div>
    </ng-container>
  </div>
  <nz-row>
    <nz-col
      nzXs="24"
      nzSm="24"
      [nzMd]="{ span: 24, push: 0 }"
      [nzXl]="{
        span: displayOpenedObjectHistory && openedObjects.length > 0 ? 21 : 24,
        push: displayOpenedObjectHistory && openedObjects.length > 0 ? 3 : 0
      }"
      [nzXXl]="{
        span: displayOpenedObjectHistory && openedObjects.length > 0 ? 21 : 24,
        push: displayOpenedObjectHistory && openedObjects.length > 0 ? 3 : 0
      }"
    >
      <app-records-list
        #recordPage
        [hidden]="selectedRecords.length !== 0 || newMode"
        [active]="!lineReadonlyModeEnabled || (selectedRecords.length === 0 && !newMode)"
        #appRecordsList
        [moduleId]="moduleId"
        [fromDraft]="fromDraft"
        (selectionChanged)="recordSelected($event)"
        [selectedRecords]="selectedRecords"
        [selectedRecordsFromCheckBox]="selectedRecordsFromCheckBox"
        [moduleFilterId]="moduleFilterId"
        (selectRecordFromCheckBoxChanged)="
          selectRecordFromCheckBoxChanged($event)
        "
        (newRecordClicked)="navigateToNew()"
        [newRecordInDrawer]="false"
        [showCheckBoxInTableMode]="
          actions.groupedActions.length !== 0 ||
          actions.ungroupedActions.length !== 0
        "
        [inModuleList]="true"
      >
      </app-records-list>
      <ng-container *ngIf="selectedRecords.length > 0 || newMode">
        <div class="module-list">
          <nz-affix
            (nzChange)="pageHeaderAffixChanged($event)"
            class="module-list-affix"
          >
            <nz-page-header
              *ngIf="!showSuccessArea"
              class="page-header"
              [nzTitle]="pageHeaderTitle"
              [nzBackIcon]="moduleStructure.module.AdditionalInformationParsed.ShowBackButton ? 'arrow-left' : null"
              (nzBack)="goBack()"
              [nzTitle]=""
            >
              <ng-template #pageHeaderTitle>
                <ng-container *ngIf="newMode">
                  {{ moduleInformation.CreateNewText | locale }}
                </ng-container>
                <ng-container *ngIf="!newMode">
                  <span *ngIf="objectDescription !== ''">
                    {{ moduleInformation.Name | locale }}
                    {{(this.fromDraft ? ' (Draft)' : '')}}
                    {{ objectDescription }}
                  </span>
                  <span *ngIf="this.objectDescription === ''">
                    <ng-template #indicatorTemplate
                      ><i nz-icon nzType="loading"></i
                    ></ng-template>
                    {{ this.moduleInformation.Name | locale }}
                    <nz-spin
                      nzSimple
                      [nzIndicator]="indicatorTemplate"
                      style="
                        display: inline;
                        float: right;
                        margin-left: 19px;
                        margin-top: 3px;
                      "
                    ></nz-spin>
                  </span>
                </ng-container>
              </ng-template>
              <nz-page-header-extra>
                <nz-space nzDirection="horizontal" *ngIf="!newMode">
                  <nz-space-item>
                    <button
                      nz-button
                      nz-tooltip
                      [nzTooltipTitle]="'Refresh' | locale"
                      (click)="recordSelected([selectedRecords[0]])"
                    >
                      <i class="fal fa-redo"></i>
                    </button>
                  </nz-space-item>
                  <nz-space-item>
                    <nz-button-group>
                      <button
                        nz-button
                        nz-tooltip
                        [nzTooltipTitle]="'Previous Record' | locale"
                        (click)="
                          recordSelected(
                            recordPage.getPrevRecord(selectedRecords[0])
                          )
                        "
                      >
                        <i class="fal fa-arrow-left"></i>
                      </button>
                      <button
                        nz-button
                        nz-tooltip
                        [nzTooltipTitle]="'Next Record' | locale"
                        (click)="
                          recordSelected(
                            recordPage.getNextRecord(selectedRecords[0])
                          )
                        "
                      >
                        <i class="fal fa-arrow-right"></i>
                      </button>
                    </nz-button-group>
                  </nz-space-item>
                  <nz-space-item *ngIf="moduleInformation.AuthorisedForCreate">
                    <button
                      style="margin-right: 8px"
                      nz-button
                      nz-tooltip
                      [nzTooltipTitle]="'New Record' | locale"
                      (click)="recordSelected([], true)"
                    >
                      <i class="fal fa-plus"></i>
                    </button>
                  </nz-space-item>
                </nz-space>
              </nz-page-header-extra>
            </nz-page-header>
          </nz-affix>
          <div class="record-page-container">
            <app-record-page
              *ngIf="recordPageInit"
              [moduleId]="this.moduleId"
              [recordId]="newMode ? undefined : selectedRecords[0]"
              [actionType]="newMode ? 'Add' : 'Edit'"
              [moduleActionType]="moduleActionType == null ? undefined : moduleActionType"
              [sourceObject]="sourceObject == null ? undefined : sourceObject"
              [sourceObjectId]="sourceObjectId == null ? undefined : sourceObjectId"
              [customActionCode]="customActionCode == null ? undefined : customActionCode"
              [inModuleList]="true"
              [fromDraft]="fromDraft"
              [urlPrefix]="urlPrefix"
              [moduleFilterId]="moduleFilterId"

              [footerAtTop]="true"
              (backButtonClicked)="newMode = false; recordSelected([])"
              (recordModelChange)="recordModelChanged($event)"
              (objectSubmitted)="objectSubmitted($event)"
            >
            </app-record-page>
          </div>
        </div>
      </ng-container>
      <div
        class="module-list-actions"
        [hidden]="
          selectedRecordsFromCheckBox.length === 0 ||
          newMode ||
          selectedRecords.length !== 0 ||
          (actions.groupedActions.length === 0 && actions.ungroupedActions.length === 0)"
      >
        <app-actions
          #actions
          [moduleInformation]="moduleInformation"
          [recordIds]="selectedRecordsFromCheckBox"
          [actionType]="'View'"
          [inLine]="true"
          [moduleId]="moduleId"
          [isTokenized]="false"
          [inModuleList]="true"
          [fromDraft]="fromDraft"
        >
        </app-actions>
      </div>
    </nz-col>
  </nz-row>
</ng-container>
